import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import './SummaryCard.scss';

const SummaryCard = ({ summaryRows = {}, summaryColumns = [], dollarColumnValues = [] }) => {

	const formatValue = (key, value) => {
		if (value === undefined || value === null || value === '') {
		  return dollarColumnValues.includes(key) ? '$0.00' : '0';
		}
		if (dollarColumnValues.includes(key)) {
		  const numericValue = parseFloat(value);
		  if (!isNaN(numericValue)) {
			// Use Intl.NumberFormat for formatting valid numbers
			return new Intl.NumberFormat('en-US', {
			  style: 'currency',
			  currency: 'USD',
			}).format(numericValue);
		  } else {
			return '$0.00';
		  }
		} else {
		  return value;
		}
	};  

  return (
	<Card className='summary-card'>
		<CardContent className='noPadding text-align-left'>
			<Typography variant='h6' component='div' className='summary-header'>
			Summary
			</Typography>
			<Table>
			<TableBody>
				<TableRow className='noPaddingBottom'>
				{summaryColumns.map((column) => (
					<TableCell key={`header-${column.key}`} align='center' className='summary-cell noBorderBottom'>
					<Typography variant='subtitle2' className='text-align-left summary-label'>
						{column.label}
					</Typography>
					</TableCell>
				))}
				</TableRow>
				<TableRow>
				{summaryColumns.map((column) => (
					<TableCell key={`data-${column.key}`} align='center' className='summary-cell noBorderBottom'>
					<Typography variant='body1' className='text-align-left summary-row-cell'>
						{formatValue(column.key, summaryRows[column.key])}
					</Typography>
					</TableCell>
				))}
				</TableRow>
			</TableBody>
			</Table>
		</CardContent>
	</Card>
  );
};

export default SummaryCard;
